import React from 'react'

import PropTypes from 'prop-types'
import styles from './SlideInner.scss'

const SlideInner = (props) => {
    const description = props.description.map((message, i) => {
        return (
            <div key={i} className={styles.slideMessage}>{message}</div>
        )
    })

    return (
        <div className={styles.base}>
            <div className={styles.slideContainer}>
                {props.children}
                <div className={styles.description}>
                    <div className={styles.slideHeader}>{props.title}</div>
                    {description}
                </div>
            </div>
        </div>
    )
}

SlideInner.propTypes = {
    title: PropTypes.element,
    description: PropTypes.array,
    children: PropTypes.node.isRequired,
}

export default SlideInner



// WEBPACK FOOTER //
// ./containers/Landing/components/SlideInner/SlideInner.jsx